import React from "react";
import TestimonialItem from "./testimonial-item";

interface Testimonial {
  id: string | number;
  title: string;
  content: string;
  imagePath: string;
  name: string;
  category: string;
  altText?: string;
}

interface TestimonialGridProps {
  testimonials: Testimonial[];
}

const TestimonialGrid: React.FC<TestimonialGridProps> = ({ testimonials }) => {
  return (
    <div className="row justify-content-center">
      {testimonials.map((testimonial) => (
        <div key={testimonial.id} className="col-12 col-sm-12 col-md-6 col-lg-4 mb-4 d-flex">
          {/* Testimonials Item */}
          <TestimonialItem
            id={testimonial.id}
            title={testimonial.title}
            content={testimonial.content}
            imagePath={testimonial.imagePath}
            name={testimonial.name}
            category={testimonial.category}
            altText={testimonial.altText}
          />
          {/* /Testimonials Item */}
        </div>
      ))}
    </div>
  );
};

export default TestimonialGrid;
